/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Combo_Recipe_Col_WeightInputs */

const vi_combo_recipe_col_weight = /** @type {(inputs: Combo_Recipe_Col_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KL/cái`)
};

/**

* @param {Combo_Recipe_Col_WeightInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const combo_recipe_col_weight = /** @type {((inputs?: Combo_Recipe_Col_WeightInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Combo_Recipe_Col_WeightInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_combo_recipe_col_weight(inputs)
});